import { render, staticRenderFns } from "./ResellerForm.vue?vue&type=template&id=0cd1e304&scoped=true&"
import script from "./ResellerForm.vue?vue&type=script&lang=js&"
export * from "./ResellerForm.vue?vue&type=script&lang=js&"
import style0 from "./ResellerForm.vue?vue&type=style&index=0&id=0cd1e304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd1e304",
  null
  
)

export default component.exports